// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-next',
  revision: 'd0d2f04ef',
  branch: 'next',
  date: 'Thu, 27 Aug 2026 14:23:43 GMT'
};